module.exports = __webpack_public_path__ + "static/media/strap.ca94f089.png";